import httpRequestEntrance from './httpRequestEntrance.js'
import Promise from 'promise'
import {cookies} from '@/common/cookieUtils'
function initPage (that) {
  if (JSON.parse(localStorage.getItem('tenant'))) {
    that.v_tenant_selected = JSON.parse(localStorage.getItem('tenant'))
    that.v_project_selected = JSON.parse(localStorage.getItem('project'))
    let {tenant,project,tenant_pub,project_pub} = cookies.getTenantProject()
    if(tenant.id && project.id && tenant.name && project.name){
      //如果从其他平台（如物联网）修改租户项目后再跳转回来
      if(that.v_tenant_selected.id != tenant_pub.id || that.v_project_selected.id != project_pub.id){
        that.v_tenant_selected = tenant_pub
        that.v_project_selected = project_pub
        localStorage.setItem('tenant',JSON.stringify(tenant_pub))
        localStorage.setItem('project',JSON.stringify(project_pub))
        cookies.setTenantProject(that.v_tenant_selected,that.v_project_selected)
        window.location.reload()
      }
    }else{
      cookies.setTenantProject(that.v_tenant_selected,that.v_project_selected)//所有租户项目在cookie里的操作都是为将租户项目带入其他域名
    }
    return Promise.resolve(true)
  } else {
    return getTenantProject(that)
  }
}
function getTenantProject (that){
  let warpRequest = new Promise((resolve)=>{
    httpRequestEntrance.httpRequestEntrance('GET', 'v1/auth/territories',
    {enabled: true, __limit: 1000}, (responseData) => {
      let res = responseData.data
      let item = res.find(item=>item.projects.length > 0)
      if(!item){resolve('nodata')}
      that.v_tenant_selected = {name: item.tenant_name, id: item.tenant_id}
      that.v_project_selected = {name: item.projects[0].project_name, id: item.projects[0].project_id}
      localStorage.setItem('tenant', JSON.stringify(that.v_tenant_selected))
      localStorage.setItem('project', JSON.stringify(that.v_project_selected))
      cookies.setTenantProject(that.v_tenant_selected,that.v_project_selected)//所有租户项目在cookie里的操作都是为将租户项目带入其他域名
      resolve(true)
    })
  })
  return warpRequest
}
export default {
  initPage
}



// WEBPACK FOOTER //
// ./src/common/tenant-project.js